import { useEffect } from 'react';
import { useRef } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { MisContainer } from 'Shared/Components/Forms/Container';
import PageContainer from 'Shared/Components/PageStructures/PageContainer';
import { DataLayerHandler } from 'Shared/GoogleTagManager/DataLayerHandler';
import { useTranslationText } from 'Shared/Translation';

const UnexpectedErrorPage: React.ComponentType<FallbackProps> = ({ resetErrorBoundary }) => {
  const navigate = useNavigate();
  const [translation] = useTranslationText();
  const { pathname } = useLocation();
  const originalPathname = useRef(pathname);

  const onChngePathName = (resetErrorBoundary: () => void) => {
    if (pathname !== originalPathname.current) resetErrorBoundary();
  };

  DataLayerHandler.addError(translation('UNEXPECTED_ERROR_HAPPEND'), String(0));
  DataLayerHandler.addPageView(translation('UNEXPECTED_ERROR_HAPPEND'));

  useEffect(() => {
    onChngePathName(resetErrorBoundary);
  }, [pathname, resetErrorBoundary]);

  return (
    <>
      <PageContainer title={''} description={''}>
        <MisContainer
          body={
            <div className='overflow-auto flex-grow-1 px-3'>
              <div className='d-flex flex-column align-items-center justify-content-center h-100'>
                <div className='text-center'>
                  <span className='mdi display-1 lh-1 mdi-information-outline text-secondary'></span>
                  <div className='h5'>{translation('UNEXPECTED_ERROR_HAPPEND')}</div>
                  <div className='d-flex justify-content-center gap-2 mt-5'>
                    <a onClick={() => navigate(-1)} className='btn btn-outline-secondary'>
                      {translation('BACK_TO_PREVIOUS_PAGE')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          }
        />
      </PageContainer>
    </>
  );
};

export default UnexpectedErrorPage;
